<template>
  <div v-if="visible" class="ai-error-notification">
    <div class="error-content">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="error-icon">
        <circle cx="10" cy="10" r="9" fill="#EF4444"/>
        <path d="M10 6V11" stroke="white" stroke-width="2" stroke-linecap="round"/>
        <circle cx="10" cy="14" r="1" fill="white"/>
      </svg>
      <div class="error-text-wrapper">
        <p class="error-message">{{ message }}</p>
        <div v-if="showAction" class="error-actions">
          <a href="#" class="error-action-link" @click.prevent="$emit('action-click')">Try again</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIErrorNotification',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'An error occurred'
    },
    showAction: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.ai-error-notification {
  margin: 0 16px 8px 16px;
  background: #FEE2E2;
  padding: 12px;
  border-radius: 20px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
}

.error-content {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.error-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.error-text-wrapper {
  flex: 1;
}

.error-message {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #EF4444;
  margin: 0 0 4px 0;
}

.error-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.error-action-link {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #004879;
  text-decoration: underline;
  cursor: pointer;
}

.error-action-link:hover {
  color: #003366;
}

.error-more-info {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666;
}
</style>
